import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

/** Web fallback for HTTPS App Link `/app/open` when the native app is not installed. */
@Component({
  template: '',
  standalone: true,
})
export class AppOpenPageComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    if (Capacitor.getPlatform() === 'web') {
      void this.router.navigateByUrl('/login', { replaceUrl: true });
    }
  }
}
